import { Button } from '@chakra-ui/react';
import NextLink from 'next/link';

export const ViewTicketButton: React.FC<{ eventId: string }> = ({
  eventId,
}) => {
  return (
    <NextLink href={`/events/${eventId}/registration`}>
      <Button variant="outline" colorScheme="gray">
        View Ticket
      </Button>
    </NextLink>
  );
};
